import React, { useState, useEffect, useRef } from "react";
import "./Donation.css";
import jsPDF from "jspdf";
import "../fonts/Amiri-Regular-normal";
import arabic from "arabic-persian-reshaper";
import bidi from "bidi-js";
import html2canvas from "html2canvas";




const plansData = [
  { title: "Sponsor an Aalim / Aalima", price: 30000 },
  { title: "Sponsor a Hafiz", price: 10000 },
  { title: "Sponsor a Widow", price: 12000 },
  { title: "Aalim's Pocket Money", price: 15000 },
  { title: "Sponsor a Madrasa", price: 180000 },
  { title: "Sponsor an Islamic Teacher", price: 300000 }
];

const Donation = () => {
  const formRef = useRef(null);
  const receiptRef = useRef(null);
  const shareOnWhatsApp = () => {
    if (!receiptId) return;

    const message = `
🧾 *Donation Receipt*
*Misbahi Welfare Mission*

🆔 Receipt ID: ${receiptId}
📅 Date: ${timestamp}

👤 Name: ${formData.name}
💰 Amount: INR ${formData.amount}
🎯 Purpose: ${formData.type}

May Allah accept your charity 🤲
`;

    const encodedMessage = encodeURIComponent(message);

    const whatsappURL = `https://wa.me/?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");
  };


  const [selectedPlan, setSelectedPlan] = useState(null);
  const [counters, setCounters] = useState({
    widows: 0,
    aalims: 0,
    women: 0,
    men: 0
  });
  const bankDetails = {
    accountName: "The Jaamiah Mueeniyyah Wakaf Committee",
    accountNumber: "37360200000182",
    bankName: "Bank of Baroda",
    branch: "Welfare Hospital Chowkadi, Bharuch",
    ifsc: "BARB0WELBRO"

  };


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    address: "",
    donateBy: "Self",
    amount: "",
    donationFor: "",
    type: ""
  });

  const [receiptId, setReceiptId] = useState("");
  const [timestamp, setTimestamp] = useState("");
  const [showReceipt, setShowReceipt] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  // Animated Counter Effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCounters((prev) => ({
        widows: prev.widows < 63 ? prev.widows + 1 : 80,
        aalims: prev.aalims < 179 ? prev.aalims + 3 : 500,
        women: prev.women < 2080 ? prev.women + 25 : 2080,
        men: prev.men < 1250 ? prev.men + 20 : 1250
      }));
    }, 30);

    return () => clearInterval(interval);
  }, []);

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan.title);
    setFormData({ ...formData, amount: plan.price });
    formRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const id = "MWM-" + Math.floor(100000 + Math.random() * 900000);
    setReceiptId(id);
    setTimestamp(new Date().toLocaleString());
    setShowReceipt(true);
  };
  const formatArabic = (text) => text;


  // 📄 Download PDF
  const downloadPDF = async () => {
    if (!receiptRef.current) return;

    setIsGeneratingPDF(true);

    // Wait for React to hide the buttons
    await new Promise((resolve) => setTimeout(resolve, 100));

    try {
      const canvas = await html2canvas(receiptRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(`MWM_Donation_${receiptId}.pdf`);
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  return (
    <div className="donation-wrapper py-5">
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-5">
          <h1 className="fw-bold donation-title">
            Jaamiah Mueeniyyah Azharul Uloom
          </h1>
          <p className="text-muted">
            A state-of-the-art all-girls Islamic institution in India.
          </p>
        </div>

        {/* SPONSORSHIP PLANS */}
        <div className="row g-4 mb-5">
          {plansData.map((plan, index) => (
            <div className="col-md-4" key={index}>
              <div
                className={`plan-card p-4 text-center ${selectedPlan === plan.title ? "active-plan" : ""
                  }`}
                onClick={() => handlePlanSelect(plan)}
              >
                <h5>{plan.title}</h5>
                <h3 className="text-success my-3">₹{plan.price} / Year</h3>

              </div>
            </div>
          ))}
        </div>

        {/* PROGRESS SECTION */}
        <div className="progress-section text-center p-5 mb-5">
          <h3 className="mb-4">Our Progress</h3>
          <div className="row">
            <div className="col-md-3">
              <h2>{counters.widows}</h2>
              <p>Widows</p>
            </div>
            <div className="col-md-3">
              <h2>{counters.aalims}</h2>
              <p>Aalim Students</p>
            </div>
            <div className="col-md-3">
              <h2>{counters.women}</h2>
              <p>Teaching Events (Women)</p>
            </div>
            <div className="col-md-3">
              <h2>{counters.men}</h2>
              <p>Teaching Events (Men)</p>
            </div>
          </div>
        </div>
        {/* BANK & QR SECTION */}
        <div className="bank-qr-section p-5 mb-5">
          <div className="row align-items-center">

            {/* QR Column */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <h4 className="mb-3">Scan & Donate</h4>
              <img
                src={process.env.PUBLIC_URL + "/bank-qr.jpeg"}
                alt="QR Code"
                className="qr-image"
              />
              <p className="mt-2 text-muted">
                Supports PhonePe • Google Pay • Paytm
              </p>
            </div>

            {/* Bank Details Column */}
            <div className="col-md-6">
              <h4 className="mb-3">Bank Transfer Details</h4>

              <div className="bank-card p-4">
                <p><strong>A/C Name:</strong> {bankDetails.accountName}</p>
                <p><strong>A/C Number:</strong> {bankDetails.accountNumber}</p>
                <p><strong>Bank Name:</strong> {bankDetails.bankName}</p>
                <p><strong>Branch:</strong> {bankDetails.branch}</p>
                <p><strong>IFSC Code:</strong> {bankDetails.ifsc}</p>
              </div>
            </div>

          </div>
        </div>
        {/* DONATION FORM */}
        <div ref={formRef} className="form-card p-5 mb-5">
          <h4 className="mb-4 text-center">Complete Your Sponsorship</h4>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              className="form-control mb-3"
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email"
              className="form-control mb-3"
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="contact"
              placeholder="Mobile Number"
              className="form-control mb-3"
              onChange={handleChange}
              required
            />

            {/* Donate By Dropdown */}

            <div className="mb-3">
              <label className="form-label fw-bold">Donate By</label>
              <select
                name="donateBy"
                value={formData.donateBy}
                className="form-control mb-3"
                onChange={handleChange}
              >
                <option value="Self">Self (પોતે)</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <textarea
              name="address"
              value={formData.address}
              placeholder="Donor Address"
              className="form-control mb-3"
              rows="3"
              onChange={handleChange}
              required
            />

            <input
              type="number"
              name="amount"
              value={formData.amount}
              placeholder="Amount (₹)"
              className="form-control mb-3"
              onChange={handleChange}
              required
            />

            <select
              name="type"
              className="form-control mb-4"
              onChange={handleChange}
            >
              <option value="">Select Donation Type</option>
              <option value="Lillah">Lillah</option>
              <option value="Zakat">Zakat</option>
              <option value="Fitra">Fitra</option>
              <option value="Sadqah">Sadqah</option>
              <option value="Fidiya">Fidiya</option>
              <option value="Usr">Usr</option>
              <option value="Isale Sawab">Isale Sawab</option>
              <option value="Niyaz">Niyaz</option>
            </select>
            <select
              name="donationFor"
              value={formData.donationFor}
              className="form-control mb-3"
              onChange={handleChange}
              required
            >
              <option value="">Donation For</option>
              <option value="Jamia Mueeniyyah Surat">
                Misbahi Mission
              </option>
              <option value="Jamia Mueeniyyah Surat">
                Chishtiya Darul Yatama
              </option>
              <option value="Jamia Mueeniyyah Bharuch">
                Jamia Mueeniyyah Bharuch
              </option>
              <option value="Chishtiya Darul Yatama">
                Jamia Mueeniyyah Surat
              </option>
            </select>


            <button className="btn btn-success w-100">
              Generate Receipt
            </button>
          </form>
        </div>

        {/* RECEIPT */}
        {showReceipt && (
          <div className="receipt-overlay">
            <div ref={receiptRef} className="receipt-modal ultra-receipt">

              <button
                className="close-btn"
                onClick={() => setShowReceipt(false)}
              >
                ✕
              </button>

              <div className="receipt-header">
                <h2>Misbahi Welfare Mission</h2>
                <p className="receipt-sub">Official Donation Receipt</p>
              </div>

              <div className="arabic-top">
                بِسْمِ ٱللَّٰهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ
              </div>

              <div className="receipt-meta">
                <div><strong>Receipt ID:</strong> {receiptId}</div>
                <div><strong>Date:</strong> {timestamp}</div>
              </div>

              <div className="divider" />

              <div className="donor-section">
                <h5>Donor Information</h5>
                <p><strong>Full Name:</strong> {formData.name}</p>
                <p><strong>Email Address:</strong> {formData.email}</p>
                <p><strong>Contact Number:</strong> {formData.contact}</p>
                <p><strong>Donate By:</strong> {formData.donateBy}</p>
                <p><strong>Address:</strong> {formData.address}</p>
                <p><strong>Donation For:</strong> {formData.donationFor}</p>
                <p><strong>Donation Purpose:</strong> {formData.type}</p>
              </div>

              <div className="amount-section">
                Total Amount Received: INR {formData.amount}
              </div>

              <div className="arabic-bottom">
                جَزَاكَ ٱللَّٰهُ خَيْرًا
              </div>

              <p className="dua-text">
                May Allah (SWT) accept your charity, grant barakah in your wealth,
                and reward you with Jannatul Firdaus. Ameen.
              </p>

              <div className="signature-area">
                Authorised Signature
                <br />
                <small>
                  This is a computer-generated receipt and does not require a physical signature.
                </small>
              </div>

              <div className="footer-note">
                Misbahi Welfare Mission | Serving Humanity for the Sake of Allah
              </div>
              <div className="btn-group mt-4 d-flex gap-2 justify-content-center">
                {!isGeneratingPDF && (
                  <div className="btn-group mt-4 d-flex gap-2 justify-content-center flex-wrap">

                    <button
                      onClick={downloadPDF}
                      className="btn btn-primary"
                    >
                      Download PDF
                    </button>

                    <button
                      onClick={shareOnWhatsApp}
                      className="btn btn-success"
                    >
                      Share on WhatsApp
                    </button>

                  </div>
                )}
              </div>


            </div>
          </div>
        )}




        <div className="text-center mt-5 small text-muted">
          © Misbahi Welfare Mission
        </div>

      </div>
    </div>
  );
};

export default Donation;
